import { render, staticRenderFns } from "./regularModal.vue?vue&type=template&id=046ce4c0&scoped=true&"
import script from "./regularModal.vue?vue&type=script&lang=js&"
export * from "./regularModal.vue?vue&type=script&lang=js&"
import style0 from "./regularModal.vue?vue&type=style&index=0&id=046ce4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ce4c0",
  null
  
)

export default component.exports